import React from "react";
import { Row, Col, Form } from "react-bootstrap";
import "./DashboardComponents.css";

// Phase 5, §30. Shared filter bar for every dashboard page. Emits plain
// { start_date, end_date, department_id, project_id, project_module_id }
// via onChange — the BACKEND still re-applies data-scope on top of these
// (§19: "Frontend filters cannot broaden access"), this only narrows.
export default function DashboardFilterBar({ filters, onChange, showDepartment = true, showProject = true }) {
  const set = (key, value) => onChange({ ...filters, [key]: value });

  return (
    <div className="perf-filter-bar">
      <Row className="g-3">
        <Col md={3} sm={6}>
          <Form.Label className="perf-filter-label" htmlFor="perf-filter-start">Start Date</Form.Label>
          <Form.Control id="perf-filter-start" className="perf-filter-input" type="date" value={filters.start_date || ""} onChange={(e) => set("start_date", e.target.value)} />
        </Col>
        <Col md={3} sm={6}>
          <Form.Label className="perf-filter-label" htmlFor="perf-filter-end">End Date</Form.Label>
          <Form.Control id="perf-filter-end" className="perf-filter-input" type="date" value={filters.end_date || ""} onChange={(e) => set("end_date", e.target.value)} />
        </Col>
        {showDepartment && (
          <Col md={3} sm={6}>
            <Form.Label className="perf-filter-label" htmlFor="perf-filter-dept">Department ID (optional)</Form.Label>
            <Form.Control id="perf-filter-dept" className="perf-filter-input" type="number" placeholder="Enter Department ID" value={filters.department_id || ""} onChange={(e) => set("department_id", e.target.value)} />
          </Col>
        )}
        {showProject && (
          <Col md={3} sm={6}>
            <Form.Label className="perf-filter-label" htmlFor="perf-filter-project">Project ID (optional)</Form.Label>
            <Form.Control id="perf-filter-project" className="perf-filter-input" type="number" placeholder="Enter Project ID" value={filters.project_id || ""} onChange={(e) => set("project_id", e.target.value)} />
          </Col>
        )}
      </Row>
    </div>
  );
}
